module.exports = __webpack_public_path__ + "img/icon_vip_priority loan@3x.5665b209.png";